<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">SMS(문자메시지)</span>
            <span class="txt">센터가 승인 요청한 SMS 발신번호를 확인하고 관리할 수 있습니다.</span>
        </div>

        <div class="com-tab">
            <button class="on">SMS 발신번호 관리</button>
            <button @click="onClickRouter('/madmin/business/smsPayment')">SMS 결제내역</button>
            <button @click="onClickRouter('/madmin/business/adminRefuseNum')">수신거부번호</button>
        </div>

        <div class="com-search-content">
            <div class="line">
                <div class="com-calendar-wrap">
                    <single-calendar :start-date="startDate" @update="startDateUpdate"></single-calendar>
                    <div class="com-dash"><span class="dash">~</span></div>
                    <single-calendar :end-date="endDate" @update="endDateUpdate"></single-calendar>
                </div>
                <select-form
                    :select-data="['기간선택', ...periodTypeList]"
                    :select-value="['', ...periodTypeValueList]"
                    :selected-value="period"
                    @update:set="(val) => (period = val)"
                ></select-form>
                <div class="com-search-input">
                    <input
                        v-model="searchStr"
                        placeholder="검색어를 입력해 주세요"
                        type="text"
                        @keyup.enter="onEventSearch"
                    />
                    <button class="search-btn" @click="onEventSearch">검색</button>
                </div>
            </div>
            <div class="line">
                <select-form :select-data="['업종선택']"></select-form>
                <select-form :select-data="['센터구분']"></select-form>
                <select-form :select-data="['계약상태']"></select-form>
                <button class="com-search-reset" @click="resetSearchContent"></button>
            </div>
        </div>

        <div class="com-table-content com-msg-content">
            <div class="table-header com-btn-area">
                <div class="left-box">
                    <button class="com-btn excel" @click="getExcel">엑셀 다운로드</button>
                </div>
                <div class="right-box">
                    <span class="txt">
                        총
                        <span class="blue">{{ count }}</span>
                        건
                    </span>
                </div>
            </div>
            <table class="com-table">
                <colgroup>
                    <col style="width: 120px" />
                    <col style="width: 120px" />
                    <col style="width: 160px" />
                    <col />
                    <col style="width: 120px" />
                    <col style="width: 120px" />
                    <col style="width: 170px" />
                    <col />
                </colgroup>
                <thead>
                    <tr>
                        <th>
                            <button>등록일</button>
                        </th>
                        <th>센터명</th>
                        <th>발신번호</th>
                        <th>등록 파일</th>
                        <th>승인여부</th>
                        <th>승인일</th>
                        <th>관리</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(request, index) in requestListData" :key="index">
                        <td>{{ request.center_phone_certification.cre_dt | formatDate }}</td>
                        <td>{{ request.center.center_nm }}</td>
                        <td>{{ request.send_no | formatPhoneNumber }}</td>
                        <td>
                            <span
                                class="reg-file"
                                v-if="request.center_phone_certification"
                                @click="openImagePopup(request.center_phone_certification.business_certification_url)"
                            >
                                사업자 등록증:
                                {{ truncate(request.center_phone_certification.business_certification_url, 20) }},
                            </span>
                            <span
                                class="reg-file"
                                v-if="request.center_phone_certification"
                                @click="openImagePopup(request.center_phone_certification.certification_url)"
                            >
                                통신증명원: {{ truncate(request.center_phone_certification.certification_url, 20) }}
                            </span>
                        </td>
                        <!-- <td>
              <span class='reg-file' v-if="request.center_phone_certification"
                @click='downloadFile(request.center_phone_certification.business_certification_url)'>
                사업자 등록증: {{ truncate(request.center_phone_certification.business_certification_url, 20) }},
              </span>
              <span class='reg-file' v-if="request.center_phone_certification"
                @click='downloadFile(request.center_phone_certification.certification_url)'>
                통신증명원: {{ truncate(request.center_phone_certification.certification_url, 20) }}
              </span>
            </td> -->
                        <!-- <td>{{ request.is_validated }}</td> -->
                        <td>{{ validatedText(request) }}</td>
                        <td>{{ request.approved_date | formatDate }}</td>
                        <td>
                            <div class="auth-status auth-apply">
                                <button
                                    class="com-btn dark-gray"
                                    @click="handleRequest(request, false)"
                                    :disabled="
                                        request.is_validated === 'APPROVED' || request.is_validated === 'REJECTED'
                                    "
                                >
                                    반려
                                </button>
                                <button
                                    class="com-btn blue"
                                    @click="handleRequest(request, true)"
                                    :disabled="
                                        request.is_validated === 'APPROVED' || request.is_validated === 'REJECTED'
                                    "
                                >
                                    승인
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="sort-bottom-area">
                <select-form
                    :select-data="[...sortTypeList]"
                    :select-value="[...sortTypeValueList]"
                    class="float-right"
                    @update:set="changeLimit"
                ></select-form>
            </div>
            <b-pagination
                v-model="pagingInfo.page"
                :per-page="pagingInfo.limit"
                :total-rows="pagingInfo.totalItems"
                align="center"
                aria-controls="my-table"
                first-class="first"
                last-class="last"
                next-class="next"
                prev-class="prev"
                @change="handlerPagenation($event)"
            ></b-pagination>
        </div>

        <!-- 이미지 미리보기 팝업 -->
        <div v-show="fileViewPop" class="layer-pop square file-view-pop" :style="{ zIndex: 33 }">
            <div class="view-content w600">
                <button class="close" @click="fileViewPop = false">
                    <span class="blind">팝업 닫기</span>
                </button>
                <div class="scroll-area com-scroll-y">
                    <p class="pop-tit">파일 미리보기</p>

                    <div
                        class="file-preview-wrap"
                        style="display: flex; justify-content: center; align-items: center; height: 100%"
                    >
                        <img
                            v-if="selectedImageUrl"
                            :src="selectedImageUrl"
                            alt="Selected image"
                            style="max-width: 100%; max-height: 100%; object-fit: contain"
                        />
                    </div>

                    <div class="bottom-btn">
                        <button class="com-btn" @click="fileViewPop = false">닫기</button>
                        <button class="com-btn blue" @click="downloadFile">다운로드</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import { pagingInfo } from '@/assets/js/common';
import paymentApi from '@/assets/js/paymentApi';
import moment from 'moment';
import XLSX from 'xlsx';
import EventBus from '../../../assets/js/eventBus';
export default {
    name: 'messageHistory',
    props: {},
    computed: {
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
    },
    watch: {
        period(newValue) {
            this.requestList();
            this.period = newValue;
            if (newValue === 'thisMonth') {
                this.startDate = moment().startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().endOf('month').format('YYYY-MM-DD');
            } else if (newValue === 'prevMonth') {
                this.startDate = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
            } else if (newValue === 'today') {
                this.startDate = moment().format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'yesterday') {
                this.startDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
            } else if (newValue === 'lastWeek') {
                this.startDate = moment().subtract(7, 'days').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'threeMonth') {
                this.startDate = moment().subtract(3, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'sixMonth') {
                this.startDate = moment().subtract(6, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'year') {
                this.startDate = moment().subtract(12, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            }
            this.onSearchList();
        },
        startDate() {
            this.requestList();
        },
        endDate() {
            this.requestList();
        },
        searchSmsType(newValue) {
            this.searchSmsType = newValue;
            this.onSearchList();
        },
        sendOk(newValue) {
            this.sendOk = newValue;
            this.onSearchList();
        },
        sender(newValue) {
            this.sender = newValue;
            this.onSearchList();
        },
    },
    data() {
        return {
            fileViewPop: false,
            centerId: '',
            startDate: moment().subtract(1, 'months').format('YYYY-MM-DD'),
            endDate: moment().format('YYYY-MM-DD'),
            periodTypeList: ['오늘', '어제', '최근 일주일', '이번 달', '지난 달', '3개월', '6개월', '12개월'],
            periodTypeValueList: [
                'today',
                'yesterday',
                'lastWeek',
                'thisMonth',
                'prevMonth',
                'threeMonth',
                'sixMonth',
                'year',
            ],
            sortTypeList: ['10줄보기', '20줄보기', '50줄보기', '100줄보기'],
            sortTypeValueList: [10, 20, 50, 100],
            // sortTypeList: [ ...this.$sortType ],
            // sortTypeValueList: [ ...this.$sortTypeValue],
            pagingInfo: { ...pagingInfo },
            searchStr: '',
            period: '',
            historyList: [],
            msgTypeList: ['SMS', 'LMS', 'MMS'], // 발송유형
            msgTypeValueList: ['S', 'L', 'M'], // 발송유형 value 값
            searchSmsType: '',
            sendOk: '',
            sender: '',
            staffNameList: [],
            staffValList: [],
            img: '', // '/img/temp/popup_1.png',
            requestListData: [],
            selectedImageUrl: null,
            selectedFileUrl: null,
            count: 0,
        };
    },
    mounted() {
        this.centerId = this.cId; // 센터id
        this.init();
    },
    filters: {
        formatDate(value) {
            if (value) {
                const date = new Date(value);
                const year = date.getFullYear();
                const month = ('0' + (date.getMonth() + 1)).slice(-2);
                const day = ('0' + date.getDate()).slice(-2);
                return `${year}-${month}-${day}`;
            }
            return '';
        },
        formatPhoneNumber(value) {
            if (value) {
                let phone = value.replace(/[^0-9]/g, ''); // 숫자가 아닌 문자 제거
                if (phone.length === 11) {
                    return phone.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3'); // 하이픈 추가
                } else if (phone.length === 10) {
                    return phone.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3'); // 하이픈 추가
                } else if (phone.length === 9) {
                    return phone.replace(/(\d{2})(\d{3})(\d{4})/, '$1-$2-$3'); // 하이픈 추가
                }
            }
            return value;
        },
    },
    methods: {
        // 초기화
        async init() {
            this.pagingInfo.page = 1;
            this.pagingInfo.skip = 10;
            this.onSearchList(); // 목록
            this.requestList();
        },
        // 페이지 이동
        onClickRouter(path) {
            this.$router.push({ path: `${path}` });
        },
        // 발송내역 조회 API 호출
        async onSearchList() {
            try {
                this.isLoading = true;
                const { data } = await this.getCenterList();
                //센터가져온걸로 페이지 세팅해 주석
                //this.setPageParams(data, 'center');
                this.historyList = data.items;
                this.isLoading = false;
                console.log('===> Success Loading centerList : ', data);
            } catch (error) {
                console.log(error);
                alert('오류가 발생했습니다.');
            }
        },
        // 발송내욕 조회 API
        getCenterList() {
            // 스웨거 검색: 메시지발송 내역
            const msgType = 'S'; // 문자만 검색
            return api.get(`/admin/api/center/${this.centerId}/message/sms`, {
                params: {
                    msgType,
                    searchStr: this.searchStr,
                    smsType: this.searchSmsType,
                    startDate: this.startDate,
                    endDate: this.endDate,
                    success: this.sendOk,
                    sendNo: '',
                    ...this.pagingInfo,
                },
            });
        },
        // 검색 종료일
        initEndDate() {
            const endDate = moment().format('YYYY-MM-DD');
            return endDate;
        },

        // 검색 시작일
        initStartDate() {
            const startDate = moment().subtract(1, 'months').format('YYYY-MM-DD');
            return startDate;
        },
        // 검색 시작일 변경 event
        startDateUpdate(val) {
            this.startDate = val;
            this.requestList();
        },

        // 검색 종료일 변경 event
        endDateUpdate(val) {
            this.endDate = val;
            this.requestList();
        },
        // 검색 조건 초기화
        resetSearchContent() {
            this.startDate = this.initStartDate();
            this.endDate = this.initEndDate();
            this.period = '';
            (this.searchSmsType = ''), (this.searchStr = '');
            this.requestList();
            EventBus.$emit('event:init', 'init');
        },
        // 검색어 입력
        onEventSearch(e) {
            if (this.searchStr.length > 0 && this.searchStr.length < 2) {
                return;
            }
            this.requestList();
        },
        // 페이징 Param 설정
        setPageParams(data) {
            this.pagingInfo.totalPages = data.meta.totalPages;
            this.pagingInfo.page = data.meta.currentPage;
            this.pagingInfo.totalItems = data.meta.totalItems;
            this.pagingInfo.itemCount = data.meta.itemCount;
        },
        // 발송 유형 타입 변환
        convertSmsType(type) {
            if (type === 'S') {
                return 'SMS';
            } else if (type === 'L') {
                return 'LMS';
            } else if (type === 'M') {
                return 'MMS';
            }
        },
        convertSmsMoney(type) {
            if (type === 'S') {
                return '8.5';
            } else if (type === 'L') {
                return '25';
            } else if (type === 'M') {
                return '60';
            }
        },
        // 한 페이지에 표시되는 줄 수 변경
        changeLimit(val) {
            this.pagingInfo.skip = val;
            this.pagingInfo.page = 1; // 페이지를 1로 리셋
            this.requestList();
        },

        getExcel() {
            const dataWS = XLSX.utils.json_to_sheet(this.historyList);
            const wb = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(wb, dataWS, 'sendHistory');
            XLSX.writeFile(wb, 'sendHistory.xlsx');
        },
        // 발송자 리스트 조회
        async senderList() {
            try {
                const { data } = await this.fetchSenderList();
                data.sort(
                    (
                        a,
                        b // order by 정렬
                    ) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0)
                );
                data.forEach((g) => {
                    this.staffNameList.push(g.namee);
                    this.staffValList.push(g.cs_center_staff_id);
                });
                console.log('발송자 리스트', data);
            } catch (error) {
                console.log(error);
                console.log('error');
            }
        },
        fetchSenderList() {
            return api.get(`/admin/api/customer-app/main/center/${this.centerId}/teachers/list`);
        },
        viewImagePop(img) {
            this.imagePop = true;
            this.img = img;
        },
        async requestList() {
            try {
                let startDate = moment(this.startDate);
                let endDate = moment(this.endDate);

                // 시작 날짜가 종료 날짜보다 늦으면 교정
                if (startDate.isAfter(endDate)) {
                    [startDate, endDate] = [endDate, startDate];
                    this.startDate = startDate.format('YYYY-MM-DD');
                    this.endDate = endDate.format('YYYY-MM-DD');
                }

                const { data } = await paymentApi.post('/admin/api/admin-management-center/request-list', {
                    startDate: this.startDate,
                    endDate: this.endDate,
                    page: this.pagingInfo.page,
                    skip: this.pagingInfo.skip,
                    searchKeyword: this.searchStr,
                });

                this.requestListData = data.list;
                this.count = data.count;

                // 페이지네이션 정보 업데이트
                this.pagingInfo.totalItems = data.count;
                this.pagingInfo.totalPages = Math.ceil(data.count / this.pagingInfo.skip);
            } catch (error) {
                console.log(error);
                alert('오류가 발생했습니다.');
            }
        },
        async handleRequest(request, isApproved) {
            const payload = {
                centerId: request.center.id,
                senderNumber: request.send_no,
                isApproved: isApproved,
            };
            try {
                const { data } = await paymentApi.put('/admin/api/admin-management-center/handle-request', payload);
                console.log('Request handled successfully', data);
                const message = data.message || (isApproved ? '승인이 완료되었습니다.' : '반려 되었습니다.'); // 메시지가 없는 경우 기본 메시지를 설정
                alert(message); // 성공 메시지를 알림으로 표시
                this.requestList(); // 목록을 다시 불러옴
            } catch (error) {
                console.error('Error handling request', error);
                if (error.response && error.response.data && error.response.data.message) {
                    alert(error.response.data.message); // 실패 메시지를 알림으로 표시
                } else {
                    alert('오류가 발생했습니다.');
                }
            }
        },
        truncate(str, length) {
            return str.length > length ? str.substring(0, length) + '...' : str;
        },
        openImagePopup(url) {
            this.selectedImageUrl = url;
            this.selectedFileUrl = url; // 파일 URL도 저장
            this.fileViewPop = true;
        },
        truncate(str, length) {
            return str.length > length ? str.substring(0, length) + '...' : str;
        },
        async downloadImage() {
            try {
                const response = await fetch(this.selectedImageUrl, { method: 'GET' });
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const blob = await response.blob();
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                const fileName = this.selectedImageUrl.split('/').pop(); // URL에서 파일 이름 추출
                link.download = fileName; // 다운로드 파일명 설정
                link.click();
                window.URL.revokeObjectURL(url);
            } catch (error) {
                console.error('There was a problem with the download.', error);
            }
        },
        startDateUpdate(val) {
            this.startDate = val;
        },
        async downloadFile() {
            if (!this.selectedFileUrl) {
                alert('다운로드할 파일이 선택되지 않았습니다.');
                return;
            }

            try {
                console.log('Downloading file from:', this.selectedFileUrl);

                // 파일 이름 추출
                const fileName = this.selectedFileUrl.split('/').pop() || 'download';
                console.log('File name:', fileName);

                // 링크 생성 및 클릭
                const link = document.createElement('a');
                link.href = this.selectedFileUrl;
                link.download = fileName; // 이 속성은 같은 도메인에서만 작동합니다
                link.target = '_blank'; // 새 탭에서 열기 (필요한 경우)
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                console.log('Download initiated');
            } catch (error) {
                console.error('Download failed:', error);
                alert('파일 다운로드에 실패했습니다. 오류: ' + error.message);
            }
        },
        endDateUpdate(val) {
            this.endDate = val;
        },
        validatedText(request) {
            switch (request.is_validated) {
                case 'NEW':
                case 'PROGRESS':
                    return '심사중';
                case 'APPROVED':
                    return '인증완료';
                case 'REJECTED':
                    return '반려';
                case null:
                    return '정보 없음'; // null 값을 처리하는 코드
                default:
                    return '';
            }
        },
        // 페이징 이벤트
        handlerPagenation(event) {
            this.pagingInfo.page = event;
            this.requestList();
        },
    },
};
</script>
<style lang="scss"></style>
